import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { NotifyModalEl } from '../Elements'
import { yupResolver } from '@hookform/resolvers'
import * as yup from 'yup'
import Button from '../../../../../../../../../Components/Buttons/Button'
import { H4 } from '../../../../../../../../../Styles/typography'
import { TextField } from '@material-ui/core'

function Notify({ onSubmit }) {
  const [loading, setLoading] = useState(false)

  const { handleSubmit, errors, register } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        message: yup.string().required('Message is required'),
      }),
    ),
    defaultValues: {
      message: '',
    },
  })

  return (
    <NotifyModalEl>
      <H4>Enter the message:</H4>
      <form
        onSubmit={handleSubmit(async ({ message }) => {
          setLoading(true)

          await onSubmit(message)
          setLoading(false)
        })}
      >
        <TextField
          name='message'
          type='text'
          label='Message'
          inputRef={register}
          error={Boolean(errors.message)}
          helperText={errors.message}
          multiline
          rows={5}
        />

        <Button
          name='Send To All'
          type='submit'
          onClick={() => {}}
          disabled={loading}
          loading={loading}
        />
      </form>
    </NotifyModalEl>
  )
}

export default Notify
